function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Status/Meldingstatus/Niet-klaar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Invisible_shape",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "Icons/Status/Meldingstatus/niet-klaar",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#EB3342",
  fillRule: "nonzero",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.44444444,
  y1: 6.4,
  x2: 13.5555556,
  y2: 13.6,
  id: "Line-11",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  fill: "#D90000",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.44444444,
  y1: 13.6,
  x2: 13.5555556,
  y2: 6.4,
  id: "Line-11",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  fill: "#D90000",
  strokeLinecap: "round"
})));
function SvgReservationDisabledCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Status/Meldingstatus/Niet klaar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationDisabledCheck);
export default __webpack_public_path__ + "static/media/Reservation_DisabledCheck.216ba44f24fdbe9e8b3b0e3ae253da58.svg";
export { ForwardRef as ReactComponent };